export interface PeacemakerDto {
  country: string
  name: string
  title: string
  contents: string
  category: number
  thumbnail?: string
  reviewAgreed?: boolean
  activityDt?: string
  activityMember?: number
  activityPlaceGb?: number
  activityPlaceTxt?: string
  activityDurationGb?: number
  materialTypeGb?: number
  deletedDocFileIds: number[]
  newFiles: { file: File, sortSeq: number }[]
  updatedOrders: { docFileId: number, sortSeq: number }[]
}
export interface HmlPeacemakerInfoModel {
  categoryId: number | null;
  participationCount: number | null;
  memberCount: number | null;
}


export default function () {
  const languageGbSn = useI18n().locale

  function _convertPeacemakerDtoToFormData(params: PeacemakerDto) {
    const formData = new FormData()
    formData.append('languageGbSn', languageGbSn.value)
    formData.append('country', params.country)
    formData.append('name', params.name)
    formData.append('title', params.title)
    formData.append('contents', params.contents)
    formData.append('category', String(params.category))

    if (params.thumbnail)
      formData.append('thumbnail', params.thumbnail)
    if (params.reviewAgreed != null)
      formData.append('reviewAgreed', String(params.reviewAgreed))
    if (params.activityDt)
      formData.append('activityDt', params.activityDt)
    if (params.activityMember != null)
      formData.append('activityMember', String(params.activityMember))
    if (params.activityPlaceGb != null)
      formData.append('activityPlaceGb', String(params.activityPlaceGb))
    if (params.activityPlaceTxt)
      formData.append('activityPlaceTxt', params.activityPlaceTxt)
    if (params.activityDurationGb != null)
      formData.append('activityDurationGb', String(params.activityDurationGb))
    if (params.materialTypeGb != null)
      formData.append('materialTypeGb', String(params.materialTypeGb))

    const fileOrders = params.newFiles.map(f => f.sortSeq)
    formData.append('newFileSortSeqList', JSON.stringify(fileOrders))
    params.newFiles.forEach(({ file }) => {
      formData.append('newFiles', file)
    })

    formData.append('deleteDocFileIds', JSON.stringify(params.deletedDocFileIds))
    formData.append('updatedOrders', JSON.stringify(params.updatedOrders))

    return formData
  }

  async function storePeacemaker(params: PeacemakerDto) {
    return await useAPI<number>('/hml/v1/peacemaker', {
      method: 'POST',
      body: _convertPeacemakerDtoToFormData(params),
    })
  }

  async function updatePeacemaker(docId: number, params: PeacemakerDto) {
    return await useAPI(`/hml/v1/peacemaker/${docId}`, {
      method: 'PUT',
      body: _convertPeacemakerDtoToFormData(params),
    })
  }

  async function fetchPeacemakerCount() {
    return await useAPI<HmlPeacemakerInfoModel[]>('/hml/v1/peacemaker/cnt', {
      method: 'GET',
    })
  }

  return {
    storePeacemaker,
    updatePeacemaker,
    fetchPeacemakerCount,
  }
}
